import React from 'react';
import { badgeToneClasses, cx } from '../theme';

export default function StatusBadge({ children, tone = 'slate', kind = 'severity', className = '' }) {
  return (
    <span
      data-coo="status-badge"
      data-coo-tone={tone}
      data-coo-kind={kind}
      className={cx(
        'inline-flex items-center',
        badgeToneClasses[tone] || badgeToneClasses.slate,
        className,
      )}
    >
      {children}
    </span>
  );
}
